import { render, staticRenderFns } from "./dahuadown.vue?vue&type=template&id=239bc952&scoped=true&"
import script from "./dahuadown.vue?vue&type=script&lang=js&"
export * from "./dahuadown.vue?vue&type=script&lang=js&"
import style0 from "./dahuadown.vue?vue&type=style&index=0&id=239bc952&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "239bc952",
  null
  
)

export default component.exports